import 'aframe';
// @ts-ignore
import {Entity} from 'aframe-react';
import React from 'react';
import Community1Thumb from "./images/community1-thumb.png"
import Community2Thumb from "./images/community2-thumb.png"

interface VRMenuProps { OnClick: (target:string) => void; }

export function VRMenu(props : VRMenuProps) {
    return (
        <>
            <Entity oculus-touch-controls="hand: left"></Entity>
            <Entity oculus-touch-controls="hand: right"></Entity>
            <Entity laser-controls="hand: right"></Entity>
            {/*<Entity cursor />*/}

            <Entity class="clickbox" primitive='a-box' position="-5 0 -5" width="8" height="4" depth="0.2" src={Community1Thumb}
            events={{click: () => props.OnClick('image-1')}}>
                <Entity text="value: Community 1;color:white;width: 10;" position="1.5 1.5 0.11" ></Entity>
            </Entity>

            <Entity class="clickbox" primitive='a-box' position="5 0 -5" width="8" height="4" depth="0.2" src={Community2Thumb}
                    events={{click: () => props.OnClick('image-2')}}>
                <Entity text="value: Community 2;color:white;width: 10;" position="1.5 1.5 0.11" ></Entity>
            </Entity>
        </>
    );
}